import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../config.json";
const url = api.url;

function Items({ currentItems }) {
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [showBioModal, setShowBioModal] = useState(false);

  const openBioModal = (staff) => {
    setSelectedStaff(staff);
    setShowBioModal(true);
  };

  const closeBioModal = () => {
    setShowBioModal(false);
    setTimeout(() => setSelectedStaff(null), 300);
  };

  return (
    <>
      <div className="my-5 py-4 grid grid-cols-2 sm:grid-cols-4 md:grid-cols-3 xl:grid-cols-5 gap-3 w-[50%] md:w-[100%] px-0">
        {currentItems &&
          currentItems.map((s) => (
            <div
              key={s._id}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              {/* Image Container */}
              <div className="relative">
                <img
                  src={s.staff && url + s.staff.avatar}
                  alt={s.staffName}
                  className="w-full h-64 object-cover"
                />
              </div>

              {/* Content Container */}
              <div className="p-6 text-center">
                {/* Name */}
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {s.staff && s.staff.title}. {s.staffName}
                </h3>
                
                {/* Role/Position */}
                <p className="text-sm text-blue-600 font-medium mb-4">
                  {s.occupation}
                </p>

                {/* Biography Button */}
                <button
                  onClick={() => openBioModal(s)}
                  className="w-full px-4 py-2 bg-blue-900 text-white text-sm font-medium rounded-full hover:bg-blue-800 transition-colors duration-200"
                >
                  Biography
                </button>
              </div>
            </div>
          ))}
      </div>

      {/* Biography Modal */}
      {showBioModal && selectedStaff && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
          onClick={closeBioModal}
        >
          <div 
            className="bg-white rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-900">Biography</h2>
              <button
                onClick={closeBioModal}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6">
              {/* Staff Info */}
              <div className="flex items-center mb-6">
                <img
                  src={selectedStaff.staff && url + selectedStaff.staff.avatar}
                  alt={selectedStaff.staffName}
                  className="w-24 h-24 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {selectedStaff.staff && selectedStaff.staff.title}. {selectedStaff.staffName}
                  </h3>
                  <p className="text-blue-600 font-medium">{selectedStaff.occupation}</p>
                  <p className="text-gray-600 text-sm">
                    {selectedStaff.staff && selectedStaff.staff.email}
                  </p>
                </div>
              </div>

              {/* Biography Content */}
              <div className="space-y-4">
                <h4 className="text-lg font-semibold text-gray-900">About</h4>
                {selectedStaff.staff && selectedStaff.staff.bio ? (
                  <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                    {selectedStaff.staff.bio}
                  </div>
                ) : (
                  <p className="text-gray-500 italic">No biography available.</p>
                )}

                {/* Research Areas */}
                {selectedStaff.staff && selectedStaff.staff.reserachInterest && selectedStaff.staff.reserachInterest.length > 0 && (
                  <div className="mt-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-3">Research Areas</h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedStaff.staff.reserachInterest.map((area, index) => (
                        <span
                          key={index}
                          className="px-3 py-1 bg-blue-100 text-blue-700 text-sm rounded-full"
                        >
                          {area}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Contact Information */}
                {selectedStaff.staff && (selectedStaff.staff.mobileNumber || selectedStaff.staff.phone) && (
                  <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Contact</h4>
                    {(selectedStaff.staff.mobileNumber || selectedStaff.staff.phone) && (
                      <p className="text-gray-700">
                        <span className="font-medium">Phone:</span> {selectedStaff.staff.mobileNumber || selectedStaff.staff.phone}
                      </p>
                    )}
                    {selectedStaff.staff.email && (
                      <p className="text-gray-700">
                        <span className="font-medium">Email:</span> {selectedStaff.staff.email}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Modal Footer */}
            <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex justify-end">
              <Link
                to={`${selectedStaff.staffId}`}
                state={{ staff: selectedStaff }}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 mr-3"
              >
                View Full Profile
              </Link>
              <button
                onClick={closeBioModal}
                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors duration-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Items;
